/*
  Where We Are Map — pins to the current or next stop.
  Shares the schedule format with wb-truck-tracker.js but stays standalone so
  either section can be used without the other.
*/
(function () {
  'use strict';

  var MIN_PER_DAY = 1440;
  var WEEK_MIN = MIN_PER_DAY * 7;
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /* Accepts "16:00", "4:00 PM", "4 PM", "4:00PM", "2:00 AM". Google Sheets
     formats time cells as 12-hour by default, so both must work. */
  function parseClock(value) {
    if (value === 0) { return 0; }
    if (!value) { return null; }
    var raw = String(value).trim().toUpperCase();
    var isPm = raw.indexOf('PM') > -1;
    var isAm = raw.indexOf('AM') > -1;
    raw = raw.replace(/[AP]M/g, '').trim();
    var parts = raw.split(':');
    var h = parseInt(parts[0], 10);
    var m = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    if (isNaN(h)) { return null; }
    if (isNaN(m)) { m = 0; }
    if (isPm && h < 12) { h += 12; }
    if (isAm && h === 12) { h = 0; }
    if (h > 23) { h = h % 24; }
    return (h * 60) + m;
  }

  function formatClock(total) {
    var mins = ((total % MIN_PER_DAY) + MIN_PER_DAY) % MIN_PER_DAY;
    var h = Math.floor(mins / 60), m = mins % 60;
    var sfx = h >= 12 ? 'PM' : 'AM';
    var d = h % 12; if (d === 0) { d = 12; }
    return d + ':' + (m < 10 ? '0' + m : m) + ' ' + sfx;
  }

  function build(slots) {
    var out = [];
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var day = parseInt(s.day, 10);
      var st = parseClock(s.start), en = parseClock(s.end);
      if (isNaN(day) || st === null || en === null) { continue; }
      var a = day * MIN_PER_DAY + st, b = day * MIN_PER_DAY + en;
      if (b <= a) { b += MIN_PER_DAY; }
      out.push({
        name: s.name || '', address: s.address || '', display: s.display || '',
        lat: parseFloat(s.lat), lng: parseFloat(s.lng),
        day: day, start: a, end: b, startClock: st, endClock: en
      });
    }
    out.sort(function (x, y) { return x.start - y.start; });
    return out;
  }

  function resolve(windows, current) {
    var offs = [0, -WEEK_MIN, WEEK_MIN];
    for (var i = 0; i < windows.length; i++) {
      for (var o = 0; o < offs.length; o++) {
        if (current >= windows[i].start + offs[o] && current < windows[i].end + offs[o] + 15) {
          return { slot: windows[i], live: true };
        }
      }
    }
    var best = null, delta = Infinity;
    for (var j = 0; j < windows.length; j++) {
      for (var k = 0; k < 2; k++) {
        var d = (windows[j].start + k * WEEK_MIN) - current;
        if (d > 0 && d < delta) { delta = d; best = windows[j]; }
      }
    }
    return best ? { slot: best, live: false } : null;
  }

  function label(slot) {
    return slot.display || (formatClock(slot.startClock) + ' - ' + formatClock(slot.endClock));
  }

  function init(root) {
    var dataEl = root.querySelector('[data-wb-map-schedule]');
    if (!dataEl) { return; }
    var slots = [];
    try { slots = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }

    var windows = build(slots);
    if (!windows.length) { return; }

    var now = new Date();
    var current = now.getDay() * MIN_PER_DAY + now.getHours() * 60 + now.getMinutes();
    var res = resolve(windows, current);
    if (!res) { return; }

    var liveUrl = root.getAttribute('data-live');
    var liveStale = parseInt(root.getAttribute('data-live-stale') || '240', 10);
    if (liveUrl && window.wbLiveGps) {
      window.wbLiveGps(liveUrl, liveStale, function (ping) {
        if (!ping) { return; }
        var eyebrow2 = root.querySelector('[data-wb-map-eyebrow]');
        var nameEl2 = root.querySelector('[data-wb-map-name]');
        var whenEl2 = root.querySelector('[data-wb-map-when]');
        var addrEl2 = root.querySelector('[data-wb-map-addr]');
        var dirEl2 = root.querySelector('[data-wb-map-directions]');
        var frame2 = root.querySelector('[data-wb-map-frame]');
        var target2 = ping.lat + ',' + ping.lng;
        if (eyebrow2) { eyebrow2.textContent = 'Parked right now at'; }
        if (nameEl2) { nameEl2.textContent = ping.label || 'The truck is out'; }
        if (whenEl2) { whenEl2.textContent = 'Live GPS \u00b7 pinned ' + ping.ageMinutes + ' min ago'; }
        if (addrEl2) { addrEl2.textContent = ''; }
        if (dirEl2) { dirEl2.setAttribute('href', 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(target2)); }
        if (frame2) {
          var z2 = parseInt(root.getAttribute('data-zoom') || '14', 10);
          frame2.setAttribute('src', 'https://maps.google.com/maps?q=' + encodeURIComponent(target2) + '&z=' + z2 + '&output=embed');
        }
      });
    }

    var slot = res.slot;
    var zoom = parseInt(root.getAttribute('data-zoom') || '14', 10);

    var eyebrow = root.querySelector('[data-wb-map-eyebrow]');
    var nameEl = root.querySelector('[data-wb-map-name]');
    var whenEl = root.querySelector('[data-wb-map-when]');
    var addrEl = root.querySelector('[data-wb-map-addr]');
    var dirEl = root.querySelector('[data-wb-map-directions]');
    var frame = root.querySelector('[data-wb-map-frame]');

    if (eyebrow) { eyebrow.textContent = res.live ? 'Parked right now at' : 'Our next stop'; }
    if (nameEl) { nameEl.textContent = slot.name; }
    if (whenEl) {
      whenEl.textContent = res.live
        ? ('Serving ' + label(slot))
        : (DAY_NAMES[slot.day] + ', ' + label(slot));
    }
    if (addrEl) { addrEl.textContent = slot.address || ''; }

    var target = (!isNaN(slot.lat) && !isNaN(slot.lng))
      ? (slot.lat + ',' + slot.lng)
      : (slot.address || slot.name);

    if (dirEl) {
      dirEl.setAttribute('href', 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(target));
    }
    if (frame) {
      /* Keyless embed — no API key, no billing, no per-load charge. */
      frame.setAttribute('src', 'https://maps.google.com/maps?q=' + encodeURIComponent(target) + '&z=' + zoom + '&output=embed');
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-wb-map]');
    for (var i = 0; i < nodes.length; i++) { init(nodes[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var n = e.target.querySelector ? e.target.querySelector('[data-wb-map]') : null;
    if (n) { init(n); }
  });
})();
